import { FadeUp } from "./Reveal";

const clientLogos = [
  { name: "JPMorgan Chase", src: "/logos/jpmorgan-chase.svg", h: "h-[18px]" },
  { name: "Cathay Pacific", src: "/logos/cathay-pacific.svg", h: "h-5" },
  { name: "Orica", src: "/logos/orica.png", h: "h-6" },
  { name: "Valiant Integrated Services", src: "/logos/valiant.png", h: "h-6" },
  { name: "Adidas", src: "/logos/adidas.svg", h: "h-8" },
  { name: "Cannes Lions", src: "/logos/cannes-lions.svg", h: "h-6" },
  { name: "Larsson & Jennings", src: "/logos/larsson-jennings.png", h: "h-5" },
  { name: "Pollenize CIC", src: "/logos/pollenize.png", h: "h-10" },
];

export default function ClientLogos({ label = "Trusted by", className = "", testId = "client-logo-strip" }) {
  return (
    <FadeUp className={className} delay={0.1}>
      <div data-testid={testId}>
        <p className="eyebrow mb-6">{label}</p>
        <ul className="grid grid-cols-2 gap-px border border-white/10 bg-white/10 sm:grid-cols-4 lg:grid-cols-8">
          {clientLogos.map((l) => (
            <li
              key={l.name}
              className="flex h-24 items-center justify-center bg-[#0B0C0E] px-6"
              data-testid={`client-logo-${l.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              <img
                src={l.src}
                alt={l.name}
                title={l.name}
                loading="lazy"
                className={`${l.h} w-auto max-w-full object-contain brightness-0 invert opacity-40 transition-opacity duration-500 hover:opacity-80`}
              />
            </li>
          ))}
        </ul>
      </div>
    </FadeUp>
  );
}
